<div class="card pt-0 mb-5">
    <div class="card-header">
        <h4>Create Batch</h4>
      </div>
    <div class="card-body">     
      <form>
       <div class="row">

        <div class="col-sm-5">
          <label class="form-label">Merchant Name <span aria-hidden="true" class="symbol required" style="color:red;">*</span> </label>
          <ng-select  (change)="onSelectMerchant($event)"
            placeholder="Merchant Name">
            <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
              {{merchant.merchant_name}} ({{merchant.MerchantId}})
            </ng-option>
          </ng-select>
        
      </div>

      <div class="col-sm-5">
        <div class="mb-3">
          <label class="form-label">Report Type <span aria-hidden="true" class="symbol required"
              style="color:red;">*</span></label>
              <select class="form-select form-control" aria-label="Default select example">
              <option value="" class="drop">Select Report Type</option>
              <option> </option>
            </select>
          <!-- <div class="text-danger mt-1">
           Please select Report Type
          </div> -->
        </div>
        </div>



       </div>
     
          <div class="row">
            
            

              
        <div class="col-sm-5">
          <label class="form-label">File Upload <span aria-hidden="true" class="symbol required"
              style="color:red;">*</span></label>
              <br>
              <div class="mb-3">
  <label class="input-group-btn">
   <input type="file" class="form-control form-control-sm"   />
          </label>
         
      </div>
    </div>
  
              <div class="col-sm-2">
                <br>
                <div class="mb-3">
                <button class="form-control btn btn-primary"
                      type="submit"
                      value="Submit">Submit
              </button>
              </div>
              </div>
          </div>
        
          </form>
    </div>
</div>
<div class="row" style="min-height: 300px">
    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
      <ag-grid-angular style="width: 100%; height: 350px;" class="ag-theme-alpine" [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [groupSelectsChildren]="true"
      [rowSelection]="'multiple'" [rowData]="rowData" [pagination]="true"></ag-grid-angular>

    </div>
  </div>
